import 'vendor.photoswipe'
import 'vendor.photoswipe-ui-default'

export default function initProductGalleryPhotoswipe() {
  const pswpElement = document.querySelector('.pswp')
  if (!pswpElement) return
  if (document.__PG_PSWP_BOUND__) return
  document.__PG_PSWP_BOUND__ = true

  const getScope = (el) => el.closest('.product__photos') || el.closest('product-images') || document

  const buildItems = (scope) => {
    const imgs = Array.from(scope.querySelectorAll('img[data-photoswipe-src][data-photoswipe-width][data-photoswipe-height]'))
    const items = []
    for (const img of imgs) {
      const src = img.getAttribute('data-photoswipe-src') || ''
      const w = parseInt(img.getAttribute('data-photoswipe-width') || '0', 10) || 0
      const h = parseInt(img.getAttribute('data-photoswipe-height') || '0', 10) || 0
      if (!src || !w || !h) continue
      items.push({ src, w, h })
    }
    return items
  }

  const getSlideIndex = (el) => {
    const slide = el.closest('.product-main-slide')
    if (!slide) return 0
    return parseInt(slide.getAttribute('data-index') || '0', 10) || 0
  }

  const openAtIndex = (scope, index) => {
    const items = buildItems(scope)
    if (!items.length) return

    let i = parseInt(index || '0', 10) || 0
    if (i < 0 || i > items.length - 1) i = 0

    const PhotoSwipe = window.PhotoSwipe
    const PhotoSwipeUI_Default = window.PhotoSwipeUI_Default
    if (!PhotoSwipe || !PhotoSwipeUI_Default) return

    const options = {
      index: i,
      bgOpacity: 0.9,
      showHideOpacity: true,
      history: false,
      focus: false,
      shareEl: false,
      captionEl: false,
      fullscreenEl: false,
      zoomEl: false,
      counterEl: false,
      preloaderEl: false,
      arrowEl: true,
      closeEl: true
    }

    const pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
    pswp.init()
  }

  document.addEventListener(
    'click',
    (e) => {
      const zoomBtn = e.target.closest('.js-photoswipe__zoom')
      if (zoomBtn) {
        e.preventDefault()
        e.stopPropagation()
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation()
        openAtIndex(getScope(zoomBtn), getSlideIndex(zoomBtn))
        return
      }

      const img = e.target.closest('img[data-photoswipe-src][data-photoswipe-width][data-photoswipe-height]')
      if (!img) return

      const within = img.closest('.product__photos') || img.closest('product-images')
      if (!within) return

      const slide = img.closest('.product-main-slide')
      if (slide) {
        const type = slide.getAttribute('data-media-type') || ''
        if (type && type !== 'image') return
      }

      const src = img.getAttribute('data-photoswipe-src') || ''
      if (!src) return

      e.preventDefault()
      e.stopPropagation()
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation()
      openAtIndex(getScope(img), getSlideIndex(img))
    },
    true
  )
}

initProductGalleryPhotoswipe()
